import React from "react";
import EmailSidebar from "../../components/Triage/emailSidebar";
import Topbar from "../../components/Recruiter/Topbar/Topbar";

const TriageSidebar = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Top bar with mobile considerations */}
      <div className="relative z-30">
        <Topbar />
      </div>

      {/* Main content area */}
      <div className="h-screen overflow-hidden">
        <EmailSidebar />
      </div>
    </div>
  );
};

export default TriageSidebar;
